import { usePageConfigUser } from 'hooks/usePageConfig'
import { PostMetric } from 'schemas/PostMetricSchema'
import { getRelativeTimeString } from 'utils/dateUtil'

const useDateTimeString = (data: PostMetric[]) => {
  const { timeZone } = usePageConfigUser()

  const times = data.map((d) => new Date(Number(d.postDate)).getTime())
  const earliest = Math.min(...times)
  const latest = Math.max(...times)

  const from = getRelativeTimeString(earliest, timeZone)
  const to = getRelativeTimeString(latest, timeZone)

  let result = from
  if (from !== to) {
    result = result.concat(` - ${to}`)
  }

  return result
}

export default useDateTimeString
